import { EventCodes } from '../../../../App/model/event-codes';

angular.module('mx.shell').component('mxShellSearch', {
	controller: MxShellSearchCtrl,
	controllerAs: 'vm',
	templateUrl: 'components/mx-shell-search/mx-shell-search.html',
});

MxShellSearchCtrl.$inject = [
	'mx.internationalization',
	'mx.shell.EventService',
	'mx.shell.SearchProviderService',
	'mx.shell.RoutingService',
	'$timeout',
	'$q',
	'$scope',
	'$element',
	'mx.shell.KeyboardNavigationService',
];

function MxShellSearchCtrl(i18n, eventService, searchProviderService, routingService, $timeout, $q, $scope, $element, keyboardNavigationService) {
	const vm = this;
	vm.searchProviderService = searchProviderService;
	vm.searchContexts = [];

	vm.$onInit = function () {
		registerHotkeys();
	};

	vm.open = openSearch;
	vm.close = closeSearch;
	vm.inputCloseClick = inputCloseClick;
	vm.performSearch = performSearch;
	vm.selectTag = selectTag;
	vm.unselectTag = unselectTag;

	eventService.subscribeTo(mx.shell.EventCodes.RouteActivated, () => closeSearch(), $scope);

	vm.searchTitle = i18n.get('shell.mx-shell-search.search');

	return vm;

	function performSearch() {
		if (vm.searchText.length >= 3) {
			const contexts = getSelectedContexts();

			eventService.dispatchEvent(EventCodes.TrackTelemetry, {
				eventName: 'Global search executed',
				senderTitle: 'Application toolbar',
				contextTypeId: contexts.map((context) => context.navigationItem?.id),
				contextTypeTitle: contexts.map((context) => context.navigationItem?.technicalName),
			});
			searchProviderService.performSearch(vm.searchText, contexts);
			closeSearch();
		} else {
			focusInput();
		}
	}

	function getSelectedContexts() {
		return vm.searchContexts.filter((context) => context.selected);
	}

	function registerHotkeys() {
		keyboardNavigationService.registerKey({
			scope: $scope,
			key: 'alt+f',
			description: i18n.get('shell.mx-shell-search.search'),
			nameInTemplate: 'hintKey',
			onRegister: function () {
				$element.on('keydown', function (e) {
					if (e.altKey && e.key === 'f') {
						if (vm.searchPanelVisible) {
							vm.close();
						}
					}
				});
			},
			callback: function (e) {
				vm.open();
				e.preventDefault();
			},
		});
	}

	function inputCloseClick() {
		if (vm.searchText) {
			clearInput();
			focusInput();
		} else {
			closeSearch();
		}
	}

	function clearInput() {
		vm.searchText = '';
	}

	function focusInput() {
		setTimeout(function () {
			$('.mx-search-input')[0].focus();
		});
	}

	async function openSearch(onOpen) {
		if (!vm.searchPanelVisible) {
			vm.searchText = searchProviderService.searchText;
			const parameters = await searchProviderService.getCurrentGlobalSearchParameters(true);
			vm.searchContexts = parameters.contexts;
			this.selectedTags = vm.searchContexts.filter((tag) => tag.selected);
			vm.searchPanelVisible = true;
			$element.addClass('opened');
			focusInput();
			_initHotKeys();
			if (onOpen) {
				onOpen();
			}
		}
	}

	function closeSearch(onClose) {
		if (vm.searchPanelVisible) {
			$timeout(function () {
				vm.searchPanelVisible = false;
				$element.removeClass('opened');
				if (onClose) {
					onClose();
				}
			});
		}
	}

	function selectTag(tag) {
		tag.selected = true;
		this.selectedTags.push(tag);
	}

	function unselectTag(tag) {
		tag.selected = false;
		this.selectedTags.splice(this.selectedTags.indexOf(tag), 1);
	}

	function _initHotKeys() {
		$timeout(function () {
			const hotKeys = new mx.shell.SearchHotkeysManager();
			const options = {
				performSearch: performSearch,
				searchText: vm.searchText,
				clearInput: clearInput,
				close: closeSearch,
			};

			hotKeys.init(options, $element);
		});
	}
}
